import { render, staticRenderFns } from "./OrderCmp.vue?vue&type=template&id=4b81a0f8&scoped=true"
import script from "./OrderCmp.vue?vue&type=script&lang=js"
export * from "./OrderCmp.vue?vue&type=script&lang=js"
import style0 from "./OrderCmp.vue?vue&type=style&index=0&id=4b81a0f8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81a0f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b81a0f8')) {
      api.createRecord('4b81a0f8', component.options)
    } else {
      api.reload('4b81a0f8', component.options)
    }
    module.hot.accept("./OrderCmp.vue?vue&type=template&id=4b81a0f8&scoped=true", function () {
      api.rerender('4b81a0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Edit/OrderCmp.vue"
export default component.exports